(() => {
  'use strict';
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-open-product-sample]');
    if (!trigger) return;
    const dialog = document.getElementById(trigger.dataset.openProductSample);
    if (!dialog || typeof dialog.showModal !== 'function') return;
    if (!dialog.dataset.sampleReady) {
      dialog.dataset.sampleReady = 'true';
      dialog.querySelector('[data-close-product-sample]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (click) => {
        if (click.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (click.clientX < box.left || click.clientX > box.right || click.clientY < box.top || click.clientY > box.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => document.body.classList.remove('wp-product-sample-open'));
    }
    dialog.showModal();
    document.body.classList.add('wp-product-sample-open');
  });
})();
